<template lang="pug">
global-form-group(
	:field-name="field.name"
	:title="field.title"
	:show-label="showLabel"
)
	div.wrap-date-native
		button(@click="inputDateShow") {{ dateLabel }}
		input(ref="inputDate" type="date"
			placeholder="Pick a date"
			v-model="date_mobile")

	div.desc(v-if="field.description") {{ field.description }}
</template>

<script>
	import GlobalFormGroup from "../../GlobalFormGroup";
	import moment, { Moment } from 'moment';

	export default  {
		name: "DateMobile",
		components: {GlobalFormGroup},
		props: {
			field: {

			},

			selected: {
				type: Object,
				default() {
					return {
						value: {
                            day: 1,
                            month: 1,
                            year: 2021
						}
					}
				}
			},
			showLabel: {
				type: Boolean,
				default: true
			},
		},

		data() {
			return {
				date_mobile: ''
			}
		},


		computed: {
			dateLabel() {
				var text;
				if (
					this.selected.value
					&& +this.selected.value.day > 0
					&& +this.selected.value.month > 0
					&& +this.selected.value.year > 0
				) {
					text = moment(`${this.selected.value.day}/${this.selected.value.month}/${+this.selected.value.year}`, 'D/M/YYYY');
				} else {
					text = moment();
				}

				return text.format('D MMM YYYY');
			}
		},

		watch: {
			date_mobile(nv) {
				var v = nv ? moment(nv, "YYYY-MM-D") : moment();
				this.changePicker(v, '');
			}
		},

		methods: {
			changePicker(value, dateString) {
				var o = Object.assign({}, this.field, {
					value: {
						day : +value.format("D"),
						month : +value.format("M"),
						year : +value.format("YYYY"),
					}
				});
				this.$emit('select', o);
			},

			inputDateShow() {
				this.$refs.inputDate.click()
			}
		}
	}
</script>

<style lang="scss">
	.wrap-date-native {
		position: relative;

		button {
			width: 100%;
			text-align: left;
			border:none;
			border-bottom: 1px solid black;
			padding-left: 0;
			padding-right: 0;
			background-color: transparent;
		}
		input {
			position: absolute;
			border: none;
			left: 0;
			top: 0;
			height: 100%;
			width: 100%;
			opacity: 0;
			z-index: 88;
			display: block;
		}
	}
</style>
